import { render, staticRenderFns } from "./WrappedButton.vue?vue&type=template&id=6f52b028&scoped=true"
import script from "./WrappedButton.vue?vue&type=script&lang=js"
export * from "./WrappedButton.vue?vue&type=script&lang=js"
import style0 from "./WrappedButton.vue?vue&type=style&index=0&id=6f52b028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f52b028",
  null
  
)

export default component.exports